export default __webpack_public_path__ + "static/minimum-amount-icon-2e3905c817033347074b5c0c821ae2e6.svg";